export default `

    <button aria-label="Close overlay" class="icon-cancel overlay-close" ng-click="closeOverlay()"></button>
    <div class="overlay-content" ng-transclude>
    </div>

`;
